import {
  getSubjectPlan,
  ThreadSlug,
} from "@twinkltech/curriculum-architect-domain-hooks";

export type UnitInfo = {
  cell?: {
    cellId: string;
    adaptationNote?: string;
  };
  cohortInfo?: {
    rowId: string;
    displayLabel: string;
  };
  startOnInfo?: {
    columnId: string;
    displayLabel: string;
  };
  endOnInfo?: {
    columnId: string;
    displayLabel: string;
  };
  resource: {
    monolithUnitId: string;
    threads: ThreadSlug[];
  };
} | null;

export const getUnitFromCell = (
  cellId?: string,
  subjectPlan?: getSubjectPlan | null,
  unitPlanMonolithUnitId: string = ""
): UnitInfo | null => {
  const resourceInfo = {
    monolithUnitId: unitPlanMonolithUnitId,
    threads:
      subjectPlan?.resources?.find(
        (resource) => unitPlanMonolithUnitId === resource.resourceId
      )?.threadSlugs || [],
  };
  if (!cellId || !subjectPlan) {
    return {
      resource: resourceInfo,
    };
  }

  const cell =
    subjectPlan?.plan.value.cells?.find((c) => c.cellId === cellId) ?? null;

  const cohortInfo = cell
    ? subjectPlan?.plan.value.rows.find((r) => r.rowId === cell.rowId) || null
    : null;

  const startOnInfo = cell
    ? subjectPlan?.plan.value.columns.find(
        (c) => c.columnId === cell.columnId
      ) || null
    : null;

  const orderedColumns =
    subjectPlan?.plan.value.columns.sort((a, b) => a.order - b.order) || [];

  const endOnInfo = cell
    ? (() => {
        const startIndex = orderedColumns.findIndex(
          (col) => col.columnId === cell.columnId
        );
        if (startIndex !== -1 && cell.span) {
          const endIndex = startIndex + cell.span - 1;
          if (endIndex < orderedColumns.length) {
            return orderedColumns[endIndex];
          }
        }
        return (
          subjectPlan?.plan.value.columns.find(
            (c) => c.columnId === cell.columnId
          ) || null
        );
      })()
    : null;

  if (
    cell === null ||
    cohortInfo === null ||
    startOnInfo === null ||
    endOnInfo === null
  ) {
    return {
      resource: resourceInfo,
    };
  }

  return {
    resource: resourceInfo,
    cell: {
      cellId: cell.cellId,
      adaptationNote: "adaptationNote" in cell ? cell.adaptationNote : "",
    },
    cohortInfo: {
      rowId: cohortInfo.rowId,
      displayLabel: cohortInfo.displayLabel,
    },
    startOnInfo: {
      columnId: startOnInfo.columnId,
      displayLabel: startOnInfo.displayLabel,
    },
    endOnInfo: {
      columnId: endOnInfo.columnId,
      displayLabel: endOnInfo.displayLabel,
    },
  };
};
